import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
const anim = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.3,
    ease: 'easeOut' as const
  }
};
export function Testimonials() {
  return <section className="bg-secondary py-12 lg:py-20 border-y border-text-primary/5" data-id="element-276">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-277">
        <div className="text-center mb-8 lg:mb-12" data-id="element-278">
          <h2 className="font-serif text-[28px] md:text-[42px] text-text-primary" data-id="element-279">
            Lo que dicen quienes ya empezaron
          </h2>
        </div>

        <motion.div {...anim} className="max-w-[700px] mx-auto bg-white rounded-3xl p-8 lg:p-12 shadow-xl border border-text-primary/5 text-center relative overflow-hidden" data-id="element-280">
          {/* Decorative background elements */}
          <div className="absolute -top-12 -right-12 w-32 h-32 bg-accent/5 rounded-full blur-2xl" data-id="element-281"></div>
          <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-accent/5 rounded-full blur-2xl" data-id="element-282"></div>

          <div className="relative z-10" data-id="element-283">
            <div className="flex justify-center space-x-1 mb-6" data-id="element-284">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-accent fill-accent" data-id="element-285" />)}
            </div>

            <p className="font-serif text-[18px] md:text-[22px] text-text-primary leading-relaxed mb-8" data-id="element-286">
              Estamos en fase de lanzamiento y construyendo nuestra base de
              clientes.
            </p>

            <div className="bg-primary/50 rounded-2xl p-6 mb-8 text-left" data-id="element-287">
              <p className="font-bold text-[14px] text-text-primary mb-4 uppercase tracking-wider" data-id="element-288">
                Si eres de los primeros 50 en unirte, recibes:
              </p>
              <ul className="space-y-3" data-id="element-289">
                <li className="flex items-start space-x-3" data-id="element-290">
                  <span className="text-accent font-bold mt-0.5" data-id="element-291">-</span>
                  <span className="text-[14px] text-text-secondary" data-id="element-292">
                    20% de descuento permanente
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-293">
                  <span className="text-accent font-bold mt-0.5" data-id="element-294">-</span>
                  <span className="text-[14px] text-text-secondary" data-id="element-295">
                    Acceso prioritario a nuevos servicios
                  </span>
                </li>
                <li className="flex items-start space-x-3" data-id="element-296">
                  <span className="text-accent font-bold mt-0.5" data-id="element-297">-</span>
                  <span className="text-[14px] text-text-secondary" data-id="element-298">
                    Tu opinión cuenta para mejorar la plataforma
                  </span>
                </li>
              </ul>
            </div>

            <motion.button whileTap={{
            scale: 0.96
          }} className="w-full sm:w-auto bg-accent text-white uppercase text-[13px] font-bold tracking-wide py-4 px-8 rounded-full inline-flex items-center justify-center space-x-2 min-h-[52px] shadow-md hover:bg-accent/90 transition-all" data-id="element-299">
              <span data-id="element-300">Sé parte de los primeros</span>
              <ArrowRight className="w-4 h-4" data-id="element-301" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}